import React, { useEffect, useRef, useState } from "react";
import {
  getCourseCategories,
  getCourses,
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import { useSelector } from "react-redux";
import moment from "moment";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};


const CollegeUniversityPlacementStep3 = ({ data, setData, setCurrentStep, currentStep }) => {

  console.log("KJU26", data);

  const initialValues = {
    placementList: data?.placementList
  }
  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();
    // setCurrentStep(currentStep + 1)

    // const customizedData = {
    //   ...formData,
    //   placementList: formData.placementList.map(({ courseCategory, ...rest }) => rest)
    // };
    console.log("FGS46", formData);

    // return
    try {
      setFormDataLoading(true);
      const res = await updateCollegeDetails(data?._id, formData);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        // toast.success(res?.message);
        setFormData(initialValues)
        setFormDataLoading(false);
        setData({
          ...data,
          placementList: formData?.placementList
        })
        setCurrentStep(currentStep + 1)
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  //// Course & Category /////
  const [courseCategories, setCourseCategories] = useState([]);
  const [courses, setCourses] = useState([]);

  const fetchCourseCategories = async () => {
    try {
      const res = await getCourseCategories();
      console.log("fetched Course Categories", res?.data);
      if (res?.status) {
        setCourseCategories(res?.data);
      } else {
        toast.error("Error while Fetching Course Categories Data");
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
      console.error("Error fetching Course Categories:", error);
    }
  };

  const fetchCourses = async (categoryId) => {
    try {
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        const retVal = res?.data.filter(item => item.categoryId === categoryId)
        return retVal
        // setCourses(val);
      } else {
        toast.error("Error while Fetching Courses Data");
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
    }
  };




  /////////////////////////////////////
  const initialItem = {
    courseCategory: "",
    courseId: "",
    year: parseInt(moment().format("Y")),
    recruiterCompanyName: "",
    totalMaleHire: 0,
    totalFemaleHire: 0,
    highestPackage: 0,
    minimumPackage: 0,
    averagePackage: 0
  };
  const [courseList, setCourseList] = useState([])

  const initialItems = data?.placementList.length ? data?.placementList : [initialItem]
  console.log("LKI124", initialItems);


  const [items, setItems] = useState(initialItems);

  const handleMultiChange = async (i, e) => {
    let newFormValues = [...items];
    if (e.target.name === "year" || e.target.name === "totalMaleHire" || e.target.name === "totalFemaleHire" || e.target.name === "highestPackage" || e.target.name === "minimumPackage" || e.target.name === "averagePackage") {
      newFormValues[i][e.target.name] = parseInt(e.target.value);
    } else {
      newFormValues[i][e.target.name] = e.target.value;
    }

    setItems(newFormValues);

    setFormData({ ...formData, placementList: newFormValues })


    if (e.target.name === "courseCategory") {
      const courseOptions = await fetchCourses(e.target.value)
      console.log("MJY117", courseOptions);
      if (courseList.length > i) {
        setCourseList(prev => {
          const updated = [...prev];
          updated[i] = courseOptions;
          return updated;
        });
      } else {
        setCourseList([...courseList, courseOptions])
      }
    }

  };

  const addItem = () => {
    if (items?.length < 5000) {
      setItems([...items, initialItem]);
    }
  };

  const removeProducts = (i) => {
    let newFormValues = [...items];
    newFormValues.splice(i, 1);
    setItems(newFormValues);
    setFormData({ ...formData, placementList: newFormValues })
  };

  const populateCourseOptions = async () => {
    try {
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        // setCourses(res?.data);
        const allAvailableCourses = res?.data
        console.log("DER188", initialItems);
        initialItems.map((item, i) => {
          const courseCategoryId = item?.courseCategory?._id || item?.courseCategory
          console.log("CDE181", allAvailableCourses, courseCategoryId);

          const courseOptions = allAvailableCourses.filter(c => c.categoryId === courseCategoryId)
          console.log("CDE167", courseOptions, i);
          setCourseList(prev => {
            const updated = [...prev];
            updated[i] = courseOptions;
            return updated;
          });
        })
      } else {
        toast.error("Error while Fetching Courses Data");
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
    }
  };

  console.log("KIU215", courseList);

  ///// ***** ////
  useEffect(() => {
    fetchCourseCategories()
    populateCourseOptions()
  }, [])

  useEffect(() => {
    setFormData(initialValues)
  }, [data])

  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">

            <div className="col-md-12 mt-3">
              <label>
                Placements <button
                  className="btn btn-sm btn-success"
                  type="button"
                  onClick={() => addItem()}
                >
                  <i class="fas fa-plus"></i> Add
                </button>
              </label>
              {items?.map((element, index) => (

                <div
                  // style={{ border: "solid 1px #ced4da", padding: "1em", margin: "0 0 1em 0", borderRadius: "0.25rem" }}
                  className="_form-inline row" key={index}>

                  <div className="col-md-3 mb-2 mt-1">
                    <label>
                      Category:
                    </label>
                    <select
                      name="courseCategory"
                      onChange={(e) => handleMultiChange(index, e)}
                      value={element?.courseCategory?._id || element?.courseCategory}
                      className="form-control"
                    >
                      <option value="">--- Choose ---</option>
                      {
                        courseCategories.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.name}
                            </option>
                          )
                        }
                        )}
                    </select>
                  </div>

                  <div className="col-md-3 mb-2 mt-1">
                    <label>
                      Course:
                    </label>
                    <select
                      name="courseId"
                      onChange={(e) => handleMultiChange(index, e)}
                      value={element?.courseId || element?.course?._id}
                      className="form-control"
                    >
                      <option value="">--- Choose ---</option>
                      {
                        courseList[index]?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.degreeName}
                            </option>
                          )
                        }
                        )}
                    </select>
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Year:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="year"
                      placeholder={`Year ${index + 1}`}
                      value={element.year || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-4 mb-2 mt-1">
                    <label>
                      Recruiter:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="recruiterCompanyName"
                      placeholder={`Company ${index + 1} name`}
                      value={element.recruiterCompanyName || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Candidate Hired % (male):
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="totalMaleHire"
                      placeholder={`Appeared ${index + 1}`}
                      value={element.totalMaleHire}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Candidate Hired % (female):
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="totalFemaleHire"
                      placeholder={`Appeared ${index + 1}`}
                      value={element.totalFemaleHire}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Highest Package:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="highestPackage"
                      placeholder={`Appeared ${index + 1}`}
                      value={element.highestPackage}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Lowest Package:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="minimumPackage"
                      placeholder={`Placed ${index + 1}`}
                      value={element.minimumPackage}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Average Package:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="averagePackage"
                      value={element.averagePackage}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>
                  <div className="col-md-12 mb-2 mt-1"><hr /></div>
                  {index ? (
                    <>

                      <div
                        style={{
                          position: "absolute",
                          right: "25px"
                        }}
                      >
                        <i class="fas fa-times"
                          style={{
                            color: "#ff0000",
                            cursor: "pointer",
                            fontSize: "1em"
                          }}
                          onClick={() => removeProducts(index)}
                        ></i>
                      </div>

                    </>
                  ) : null}




                </div>

              ))}
            </div>

          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 2 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityPlacementStep3;
